import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import { apiFetch } from "../modules/api";

const GeolocationContext = createContext();

export function GeolocationProvider({ children }) {
  const [error, setError] = useState(null);
  const positionRef = useRef(null);

  useEffect(() => {
    if (!("geolocation" in navigator)) {
      setError("Geolocalización no disponible");
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
        const newPos = {
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
          timestamp: pos.timestamp,
        };

        positionRef.current = newPos; 
      },
      (err) => setError(err.message),
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 15000,
      }
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, []);

  useEffect(() => {
    let intervalId = null;

    const tick = async () => {
      try {
        const currentScreen = global.currentRouteName || '';
        const pos = positionRef.current;
        if (currentScreen === 'listadoTiendas' || currentScreen === 'acceso' || currentScreen === '') return;
        if (!pos || !pos.latitude || !pos.longitude) return;

        const altitude = pos.altitude || '';
        const latitude = pos.latitude;
        const longitude = pos.longitude;

        const datos = '{"operador" : "' + (global.gOperador || '') + '","determinante" : "' + (global.gDeterminante || '') + '","latitude" : "' + latitude + '","longitude" : "' + longitude + '","altitude" : "' + altitude + '"}';
        console.log("datos", datos);
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: datos
        };

        const response = await apiFetch(global.gApiPath + "/api/calcularDistancia", requestOptions);
        const json = await response.json();
        if (json.estatus == "error" && json.mensaje.startsWith("Error calculando distan")) {
          alert(gOperador.toUpperCase() + " - " + gDeterminante + " Ocurrió un problema al obtener tu ubicación, por favor asegúrate de tener el GPS encendido y con permisos para la aplicación.");
          window.location.href = "./acceso";
        } else if( json.estatus != "bien") {
          alert(gOperador.toUpperCase() + " - " + gDeterminante + " Te has alejado de la tienda, por favor regresa para seguir usando la aplicación.");
          window.location.href = "./acceso";
        }
      } catch (e) {
        alert('Polling calcularDistancia error', e);
      }
    };

    tick();
    intervalId = setInterval(tick, global.pooleoDistanciaTienda * 60 * 1000);

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  return (
    <GeolocationContext.Provider value={{ positionRef, error }}>
      {children}
    </GeolocationContext.Provider>
  );
}

export const useGeolocation = () => useContext(GeolocationContext);